<template>
    <div class="marginCon">
        <Card>
            <!-- 搜索 -->
            <div v-if="offModel">
                 <div class="top" v-if='roleType==1'>
                    <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("firmwarePlan.addButton")}}</Button>
                </div>

                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>
             <!-- 更改状态弹框组件 -->
            <ChangeDialog ref="changeChild" @ievent = "ievent(1)" :title='$t("firmwareVersion.changeTitle")' :cont='$t("firmwareVersion.changeCont")'></ChangeDialog>

            <!-- 编辑 / 添加  模态框组件 -->
            <ModelBox :showModel.sync="addBox.showModel" :offModel.sync='offModel' :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>

            <!-- 删除弹框组件 -->
            <ChangeDialog ref="deleteChild" @ievent = "ievent(2)"  :title='$t("orderManage.deletModel.changeTitle")' :cont='$t("orderManage.deletModel.changeCont")'></ChangeDialog>

        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import ChangeDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import ModelBox from './component/planAddModel.vue';
import moment from 'moment'; // 引入删除弹框组件
import { mapState } from 'vuex'
    export default {
        name: "firmwareVersion",
        components: {
            ChangeDialog,
            ModelBox
        },
        data(){
            return{
                loading: true,
                offModel: true,
                type:1,
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                tableList:{
                    tableData:[],
                    tableDataAll:[],
                    hasSelectData:{}
                },
                paging:true
                
               
            }
        },
        computed:{
           ...mapState(['local','selectId']),
           roleType(){
	        	let res = '2'
	        	if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        	 res = this.$store.state.uInfo.roleType
	        	}
	        	return res
	        },
           titleName(){
               return [
                    {
                        title:this.$t('appPlan.titleName.id'),
                        'title-zh-CN':'计划编号',
                        'title-en-US':'Id',
                        key: 'id',
                        minWidth: 120,
                        sortable: true,
                        tree: true
                    },
                    {
                        title:this.$t('appPlan.titleName.canUseDate'),
                        'title-zh-CN':'计划时间',
                        'title-en-US':'Plan date',
                        key: 'canUseDate',
                        minWidth: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.canUseDate*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appPlan.titleName.appId'),
                        'title-zh-CN':'应用编号',
                        'title-en-US':'App id',
                        key: 'appId',
                        minWidth: 110
                    },
                    {
                        title:this.$t('appPlan.titleName.version'),
                        'title-zh-CN':'版本号',
                        'title-en-US':'Version',
                        key: 'version',
                        minWidth: 110
                    },
                     {
                        title:this.$t('appPlan.titleName.releaseType'),
                        'title-zh-CN':'发布类型',
                        'title-en-US':'Release type',
                        key: 'releaseType',
                        minWidth: 130,
                        render:(h, params)=>{
                             let obj = {'1':this.$t("selectList.releaseTypeList.beta"),'2':this.$t("selectList.releaseTypeList.release")}
                             let stext = obj.hasOwnProperty(params.row.releaseType) ? obj[params.row.releaseType] : params.row.releaseType
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appPlan.titleName.appStatus'),
                        'title-zh-CN':'app状态',
                        'title-en-US':'Status',
                        key: 'appStatus',
                        minWidth: 110,
                        render:(h, params)=>{
                             let obj = {'1':this.$t("selectList.appStatusList.Online"),'2':this.$t("selectList.appStatusList.Expired")}
                             let stext = obj.hasOwnProperty(params.row.appStatus) ? obj[params.row.appStatus] : params.row.appStatus


                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appPlan.titleName.os'),
                        'title-zh-CN':'系统',
                        'title-en-US':'Operational',
                        key: 'os',
                        minWidth: 120,
                        render:(h, params)=>{
                             let obj = {'1':'android','2':'ios'}
                             let stext = obj[params.row.os]
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appPlan.titleName.deviceGroupName'),
                        'title-zh-CN':'用户组',
                        'title-en-US':'User group',
                        key: 'deviceGroupName',
                        minWidth: 160,
                         render:(h, params)=>{
                             let stext = ''
                             if(params.row.releaseForAll){
                                 stext = this.$t("firmwarePlan.allGroup")
                             }else{
                                 stext = params.row.groupName || params.row.deviceGroupName
                            
                             }
                             return h('div',stext || '')
                        }
                    },
                    {
                        title:this.$t('appPlan.titleName.totalUser'),
                        'title-zh-CN':'用户数',
                        'title-en-US':'User count',
                        key: 'totalUser',
                        minWidth: 130
                    },
                   
                    {
                        title:this.$t('appPlan.titleName.completeUpdateUser'),
                        'title-zh-CN':'更新数',
                        'title-en-US':'Update count',
                        key: 'completeUpdateUser',
                        minWidth: 130
                    },
                    {
                        title:this.$t('appPlan.titleName.whetherRun'),
                        'title-zh-CN':'计划状态',
                        'title-en-US':'Plan status',
                        key: 'whetherRun',
                        minWidth: 120,
                        render:(h, params)=>{
                             let flag = params.row.whetherRun?'1':'2'
                             let obj = {'1':this.$t("selectList.whetherRun.Running"),'2':this.$t("selectList.whetherRun.Stoped")}
                             let stext = obj.hasOwnProperty(flag) ? obj[flag] : flag
                             return h('div',stext || '')
                        }
                    },
                    {
					    title:this.$t('appPlan.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
					    minWidth:this.roleType==1?160:110,
                        key: "id",
                        // fixed:'right',
					    render: (h, params) => {
                            let that = this
                           
                            return [h('div',
                                       { 
                                        style:{
                                            display: "flex",
                                            justifyContent:'center'
                                            }
                                        },[ 
                                             h('Button', {
					                            props: {
                                                    type: "error",
                                                    size: 'small'
                                                },
                                                style:{
                                                    'margin-right':'5px',
                                                    'display':this.roleType==1?'block':'none'
                                                },
					                            on: {
					                                click: () => { this.changeStatus(params.row,'deleteChild') }
					                            }
					                        }, that.$t("delete")),
                                             h('Button', {
					                            props: {
                                                    type: "info",
                                                    size: 'small'
                                                },
                                                style:{
                                                    'margin-right':'5px',
                                                    'display':this.roleType==1?'block':'none'
                                                },
					                            on: {
					                                click: () => { this.addData(2,params.row) }
					                            }
					                        }, that.$t("edit")),
                                            h('Button', {
					                            props: {
                                                    type: params.row.whetherRun?"error":"primary",
                                                    size: 'small'
                                                },
                                                style:{
                                                },
					                            on: {
					                                click: () => { this.changeStatus(params.row,'changeChild') }
					                            }
					                        }, params.row.whetherRun?that.$t("firmwareVersion.stop"):that.$t("firmwareVersion.start"))
                                         ]
                             )]
					    }
					}
                ]
           } 
        },
        created (){
           
            this.getData()
        },
       
        methods: {
            addData(type,item={}) {  //添加或编辑数据
                if(this.roleType==2) return
                this.addBox.showModel = true
                this.offModel = false
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = item
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    // this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            changeStatus(item,type){//更改状态
                this.tableList.hasSelectData = item;
                 this.$refs[type].showit();
            },
            ievent(type) {// 更改状态
                // console.log('更改状态',this.tableList.hasSelectData.id)
                if(type==1){
                    let getData = {
                        id: this.tableList.hasSelectData.id,
                        whetherRun: !this.tableList.hasSelectData.whetherRun,
                        dealerId:this.selectId
                    }
                    this.axios.post(this.config.urlArray.appPlansRun, getData).then((result)=>{
                        common.ajaxMsg(result.data,true,()=>{
                            this.$refs.changeChild.recancel();
                            this.getData();
                        })
                    }).catch((err)=>{
                        // common.msg('error','删除失败')
                    })

                }else if(type==2){
                    if(this.roleType==2) return
                    this.axios.post(this.config.urlArray.appPlansDel, {id:this.tableList.hasSelectData.id,dealerId:this.selectId}).then((result)=>{
                        common.ajaxMsg(result.data,true,()=>{
                            this.$refs.deleteChild.recancel();
                            this.getData();
                        })
                    }).catch((err)=>{
                        // common.msg('error','删除失败')
                    })

                }
                 
            },
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId
                    }
                }
                this.axios.post(this.config.urlArray.appPlansList,getData.params).then((result) => {
                    // common.ajaxMsg(result.data,false,()=>{

                    //     let resData = result.data.data
                    //     //处理数组
                    //     if(resData){
                    //         this.tableList.tableData = resData  //渲染数据
                    //         this.page.total = result.data.data.length
                    //         this.loading = false
                    //     }else{
                    //         this.tableList.tableData = []
                    //         this.page.total = 0
                    //         this.loading = false
                    //         return false
                    //     }
                    // });
                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data
                        
                        if(resData){
                            this.tableList.tableDataAll  =  resData
                        
                            if(!resData.meta){//分页不生效
                                this.paging = false
                                this.page.total = resData.length
                                // Object.keys(params).forEach(key => {
                                //   if (params[key] === '' || params[key] === undefined || params[key] === null) return this.tableList.tableDataAll 
                                //   this.tableList.tableDataAll = this.tableList.tableDataAll.filter(p => p[key] === null || p[key] === params[key])
                                // })
                                this.getDataPage()
                            }else{
                                this.tableList.tableData = resData
                                this.page.total = resData.meta.count
                            }
                            
                            this.loading = false
                        }else{
                            this.tableList.tableData = []
                            this.page.total = 0
                            this.loading = false
                            return false
                        }
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            }, 
            getDataPage(){
                let start = (this.page.current-1)*this.page.pageSize
                let end = (this.page.current)*this.page.pageSize
                let key =  this.page.key
                let order = this.page.order

                this.tableList.tableDataAll = this.tableList.tableDataAll.sort((a,b)=>{
                    if(order=='asc'){
                       return  a[key] === b[key] ? 0 : a[key] > b[key] ? 1 : -1
                    }else if(order=='desc'){
                       return  b[key] === a[key] ? 0 : b[key] > a[key] ? 1 : -1
                    }
                    
                })

                this.page.total =  this.tableList.tableDataAll.length
               this.tableList.tableData = this.tableList.tableDataAll.slice(start,end)
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                if(this.paging){
                    this.getData()          
                }else{
                    this.page.current = 1
                    this.getDataPage()  
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                if(this.paging){
                    this.getData()          
                }else{
                    this.getDataPage()  
                }
            }
        }
    }
</script>



